<template>
    <div>
      <video ref="videoElement" disablePictureInPicture class="video-js"></video>
    </div>
  </template>
  
  <script>
  import videojs from 'video.js';
  import 'video.js/dist/video-js.min.css';
  import 'videojs-contrib-hls';
  


  export default {
    name: 'HlsVideoPlayer',
    props: {
      src: {
        type: String,
        required: true,
      },
      options: {
        type: Object,
        default: () => ({}),
      },
    },
    mounted() {
      this.initPlayer();
    },
    beforeDestroy() {
      this.destroyPlayer();
    },
    methods: {
      initPlayer() {
        this.player = videojs(this.$refs.videoElement, {
          ...this.options,
          sources: [{ src: this.src, type: (this.src || '').endsWith('.mp4') ? 'video/mp4' : 'application/x-mpegURL' }],
          controlBar: {
            fullscreenToggle: false
          }
        });               
      },
      destroyPlayer() {
        if (this.player) {
          this.player.dispose();
          this.player = null;
        }
      },
    },
  };
  </script>
  

  <style>

  .video-js .vjs-picture-in-picture-control {
    display: none;
  }

</style>